import { z } from 'zod';

export const ConsumerWorkshopItemSchema = z.object({
  tenantId: z.uuid(),
  partyId: z.uuid(),
  workshopName: z.string().min(1),
});
export type ConsumerWorkshopItem = z.infer<typeof ConsumerWorkshopItemSchema>;

export const ConsumerWorkshopsResponseSchema = z.object({
  items: z.array(ConsumerWorkshopItemSchema),
});
export type ConsumerWorkshopsResponse = z.infer<typeof ConsumerWorkshopsResponseSchema>;
